import { Job } from "../model/Job";

export function sortByHighlightJobs(jobs: Job[]) {
    return jobs.sort((a, b) => {
        if (a?.isHighlight && !b?.isHighlight) return -1;
        if (!a?.isHighlight && b?.isHighlight) return 1;
        if (a?.createdAt && b?.createdAt) return a.createdAt > b.createdAt ? -1 : 1;
        else return 0
    })
}